import { Link, useNavigate } from "react-router-dom";
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Form } from 'semantic-ui-react'
import { DangerText, ScreenHeight, TitleText, ImageContainer } from 'components'
import { AppPrimaryButton, CommanAuthScreenLogin, FormTextFormField, FormOTPField } from "elements";
import { Images } from "assets";
import { useTabletAndBelowMediaQuery } from "layout";

const LoginSchema = yup.object().shape({
    InviteTo: yup.string().trim("Email does not allow spaces").strict().required('Email is required'),
    InviteCode: yup.string().required('Code is required'),
})

export const VerificationScreen = () => {

    const navigate = useNavigate();
    const [error, setError] = useState('');
    const isMobile = useTabletAndBelowMediaQuery()

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(LoginSchema),
    })

    const submit = formData => {
        setError('')
        // Do not POST user/InviteToken here. That call returns a blank
        // token (CompanyId 0, RoleId 0, FullName null) and the password
        // step then opens a new inactive company instead of joining the
        // company stored by SendInviteToken.
        navigate('/set-password', {
            state: {
                InviteTo: formData.InviteTo,
                InviteCode: formData.InviteCode,
            },
        })
    }

    return (
        <ScreenHeight className="container">
            <CommanAuthScreenLogin isMobile={isMobile}>
                <TitleText>
                    <ImageContainer
                        src={Images.Logo}
                        className="img"
                    />
                    <span>Verify User</span>
                </TitleText>
                <Form
                    noValidate
                    onSubmit={handleSubmit(submit)}
                    className="mt-5"
                >
                    <FormTextFormField
                        control={control}
                        label="Email"
                        name="InviteTo"
                        placeholder="Email"
                        errors={errors?.InviteTo}
                        defaultValue=""
                    />
                    <FormOTPField
                        control={control}
                        label="Code"
                        name="InviteCode"
                        placeholder="Code"
                        errors={errors?.InviteCode}
                        defaultValue=""
                        otpLength={6}
                    />
                    {error && <DangerText>{error}</DangerText>}
                    <AppPrimaryButton fluid className="mt-2">Verify</AppPrimaryButton>
                    <Link to="/sign-in" className="d-flex justify-content-center">
                        <div basic className="mt-3">Log in</div>
                    </Link>
                </Form>
            </CommanAuthScreenLogin>
        </ScreenHeight>
    )
}
